import tippy from 'tippy.js';

function initTooltips() {
    const tooltips = document.querySelectorAll('.js-tooltip');

    tooltips.forEach(el => {
        if (el.querySelector('.js-tooltip-content')) {
            tippy(el, {
                content: el.querySelector('.js-tooltip-content').innerHTML,
                placement: 'top-start',
                interactive: true,
                allowHTML: true,
                animation: 'fade',
                duration: 300,
                maxWidth: 250,
                delay: [0, 500],
            })
        }
    })
}

function reInitTooltips() {
    const tooltips = document.querySelectorAll('.js-tooltip');

    tooltips.forEach(el => {
        const tippyInstance = tippy(el);
        tippyInstance.destroy();
    });

    initTooltips();
}

initTooltips();

export {initTooltips, reInitTooltips}